import React, { useState } from 'react';
import { X } from 'lucide-react';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

function ContactModal({ onClose }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message }),
      });
      const data = await res.json();
      if (data.ok) {
        setSent(true);
      } else {
        setError(data.error || 'Something went wrong.');
      }
    } catch {
      setError('Could not connect. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="contact-modal" onClick={e => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}><X size={18} /></button>

        {sent ? (
          <div className="contact-success">
            <h2>Message sent!</h2>
            <p>We'll get back to you at {email}.</p>
            <button className="contact-submit-btn" onClick={onClose}>Close</button>
          </div>
        ) : (
          <>
            <h2 className="contact-title">Contact Us</h2>
            <p className="contact-sub">Questions, feedback, or issues — we're here.</p>
            <form className="contact-form" onSubmit={handleSubmit}>
              <label className="contact-label">Name
                <input className="contact-input" value={name} onChange={e => setName(e.target.value)} required placeholder="Your name" />
              </label>
              <label className="contact-label">Email
                <input className="contact-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="you@example.com" />
              </label>
              <label className="contact-label">Message
                <textarea className="contact-textarea" value={message} onChange={e => setMessage(e.target.value)} required placeholder="What's on your mind?" rows={5} />
              </label>
              {error && <p className="contact-error">{error}</p>}
              <button className="contact-submit-btn" type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default ContactModal;
